import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ec449c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Menu")
const _hoisted_2 = { class: "h-full flex flex-col justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Firma auswählen")
const _hoisted_4 = {
  slot: "content",
  class: "p-2"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Profil")
const _hoisted_6 = {
  slot: "content",
  class: "p-2"
}
const _hoisted_7 = { class: "flex flex-row items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w-full text-zewotherm-grey text-xs font-bold p-4" }, "v1.5.0", -1))

import { Storage } from '@capacitor/storage'
import {
  IonContent,
  IonHeader,
  IonItem,
  IonToolbar,
  IonMenu,
  IonAccordionGroup,
  IonAccordion,
  IonLabel,
  IonRadio,
  IonImg,
  IonRadioGroup,
  IonTitle,
  menuController,
} from '@ionic/vue'
import { useCompany } from '@/store/company'

import { loadingController } from '@ionic/core'
import { useCurrentUser } from '@/store/currentUser'
import { computed } from '@vue/reactivity'

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuView',
  emits: ["loadData"],
  setup(__props, { emit }: { emit: ({
  (e: "loadData", v: void): Promise<void>
}), expose: any, slots: any, attrs: any }) {

const companyStore = useCompany()
const currentUserStore = useCurrentUser()

const username = computed(() => {
  return currentUserStore.currentUser.user.first_name + " " + currentUserStore.currentUser.user.last_name
})



async function logOut() {
  try {
    await Storage.clear()
    history.go()
  } catch(e) {
    console.error(e)
  }
}

async function setActiveCompany(companyId: number) {
  await menuController.close()
  const loading = await loadingController.create({
    message: "Lade Daten..."
  })
  await loading.present()
  await companyStore.setActiveCompany(companyId, currentUserStore.jwtKey, true);
  await emit("loadData")
  await loading.dismiss()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonMenu), {
    side: "start",
    "menu-id": "homeMenu",
    "content-id": "main"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), { class: "font-bold" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(IonAccordionGroup), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonAccordion), { value: "Firma" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), {
                      class: "text-lg",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { class: "font-bold" }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(IonRadioGroup), {
                        value: _unref(companyStore).activeCompany.id
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companyStore).allCompanies, (company, index) => {
                            return (_openBlock(), _createBlock(_unref(IonItem), {
                              onClick: ($event: any) => (setActiveCompany(company.id)),
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonLabel), { class: "font-semibold" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(company.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_unref(IonRadio), {
                                  style: _normalizeStyle('--color-checked: ' + _unref(companyStore).activeCompany.color),
                                  slot: "start",
                                  value: company.id
                                }, null, 8, ["style", "value"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonAccordion), {
                  id: "profilAccordion",
                  value: "Profil"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), {
                      class: "text-lg",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { class: "font-bold" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_unref(IonImg), {
                          src: _unref(currentUserStore).currentUser.user.photo_url,
                          class: "h-12"
                        }, null, 8, ["src"]),
                        _createVNode(_unref(IonLabel), { class: "text-lg ml-3" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(username)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("button", {
                        id: "logoutButton",
                        onClick: logOut,
                        style: _normalizeStyle('background-color: ' + _unref(companyStore).activeCompany.color),
                        class: "h-10 mt-3 w-full p-2 text-white font-bold rounded-lg outline-none"
                      }, "Ausloggen", 4)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_8
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})